export const BUCKETS = {
    bucketAssets: 'pico-imports-assets'
};
